module.exports = __webpack_public_path__ + "img/Courses-Card-Type-4.8f7a6a04.png";